export const SuperUserRoutes = [
  { path: '', lazy: () => import('./pages/admin.su') },
  { path: 'organizations', lazy: () => import('./pages/admin.su.organizations') },
  { path: 'users', lazy: () => import('./pages/admin.su.users') },
  { path: 'accounting', lazy: () => import('./pages/admin.su.accounting') },
  { path: 'scripts', lazy: () => import('./pages/admin.su.scripts') },
  { path: 'audits', lazy: () => import('./pages/admin.su.audits') },
  { path: 'testing', lazy: () => import('./pages/admin.su.testing') },
  { path: 'notification-templates', lazy: () => import('./pages/admin.su.notification-template') },
  { path: 'notification-templates/:id', lazy: () => import('./pages/admin.su.notification-template.$id') },
  { path: 'notification-templates/create', lazy: () => import('./pages/admin.su.notification-template.create') },
]
